import { useTravelAssistantEntry } from "@/hooks/use-travel-assistant-entry"

import {
  resolveMarketingEntryCta,
  type MarketingEntryCtaDecision,
} from "@/lib/marketing-entry-cta"
import { selectSessionStatus } from "@/lib/storage/auth-slice"
import { useAppSelector } from "@/lib/storage/hooks"
import {
  selectUserIsAnonymous,
  selectUserProfile,
  selectUserProfileLoaded,
} from "@/lib/storage/user-slice"

export function useMarketingEntryCta(options?: {
  initialProvider?: string
}): MarketingEntryCtaDecision & {
  onSetup: () => void
  setupDisabled: boolean
} {
  const sessionStatus = useAppSelector(selectSessionStatus)
  const isAnonymous = useAppSelector(selectUserIsAnonymous)
  const userProfile = useAppSelector(selectUserProfile)
  const userProfileLoaded = useAppSelector(selectUserProfileLoaded)

  const { start, disabled: setupDisabled } = useTravelAssistantEntry({
    source: "home",
    createNewChat: true,
    registerOnHome: true,
  })

  const initialProvider = options?.initialProvider
  const decision = resolveMarketingEntryCta({
    sessionReady: sessionStatus !== "loading",
    initialIsRegistered: !!initialProvider && initialProvider !== "anonymous",
    isAnonymous,
    userProfileLoaded,
    hasSetUpTravelAssistant: !!userProfile.has_set_up_travel_assistant,
    hasShallowMemory: !!userProfile.has_shallow_memory,
  })

  return {
    ...decision,
    onSetup: start,
    setupDisabled,
  }
}
